import loginReducer from './authDetails';
import merchantReducer from './merchantSlice';
import clientReducer from './clientSlice';

export default {
  login: loginReducer,
  merchant: merchantReducer,
  client: clientReducer,
};
